export default __webpack_public_path__ + "static/media/4.cbd431fa.jpg";